<ng-template #collectionFilters>
    <div class="br-flex br-flex-wrap br-items-center br-gap-2">
      <select class="br-form-select br-form-select--sm br-w-auto"
              [(ngModel)]="filter.category" (ngModelChange)="load()"
              aria-label="Category">
        <option value="">All categories</option>
        <option *ngFor="let category of categories" [value]="category">{{ category }}</option>
      </select>
      <label class="br-inline-flex br-items-center br-gap-1 br-small br-text-muted">
        From
        <input class="br-form-control br-form-control--sm"
               type="datetime-local" [(ngModel)]="filter.from" />
      </label>
      <label class="br-inline-flex br-items-center br-gap-1 br-small br-text-muted">
        To
        <input class="br-form-control br-form-control--sm"
               type="datetime-local" [(ngModel)]="filter.to" />
      </label>
      <button type="button" class="br-btn br-btn--primary br-btn--sm" (click)="load()">Apply</button>
    </div>
</ng-template>

<ng-container *workspaceView="'full'">
<div class="workspace-page br-compact-page">
  <div class="workspace-page__panel workspace-page__panel--card">
    <header class="workspace-page__heading">
      <h1 class="workspace-page__title">Audit Log</h1>
    </header>
  <app-data-table [(search)]="collectionSearch" #table [columns]="columns" [fetch]="fetch"
                  searchPlaceholder="Event, user or IP"
                  columnPickerKey="admin-audit-log"
                  [resizableColumns]="true"
                  [pageSize]="50" [pageSizeOptions]="[25, 50, 100, 200]"
                  emptyText="No audit entry matches those filters."
                  (queryChange)="onQueryChange()"
                  [rowActions]="auditActions">

    <div dt-filters><ng-container *ngTemplateOutlet="collectionFilters"></ng-container></div>

    <ng-template dtCell="createdAt" let-r>
      {{ r.createdAt | date:'yyyy-MM-dd HH:mm:ss':'UTC' }}
    </ng-template>

    <ng-template dtCell="category" let-r>{{ r.category }}</ng-template>
    <ng-template dtCell="message" let-r>{{ r.message }}</ng-template>
    <ng-template dtCell="userEmail" let-r>
      <span *ngIf="r.userEmail">{{ r.userEmail }}</span>
      <span *ngIf="!r.userEmail" class="br-cell-empty">System</span>
    </ng-template>
    <ng-template dtCell="ipAddress" let-r>
      <span *ngIf="r.ipAddress">{{ r.ipAddress }}</span>
      <span *ngIf="!r.ipAddress" class="br-cell-empty">&#8212;</span>
    </ng-template>

  </app-data-table>

  <ng-template #auditActions let-r>
    <button mat-icon-button (click)="showDetail(r)"
            matTooltip="View details" aria-label="View audit details">
      <br-icon>info_outline</br-icon>
    </button>
  </ng-template>
  </div>
</div>
</ng-container>

<ng-container *workspaceView="'compact'">
  <section class="workspace-page workspace-page--full">
    <h1 class="workspace-page__title">Audit Log</h1>

    <app-data-list #compactList [fetch]="fetch" [(search)]="collectionSearch">
      <div list-filters><ng-container *ngTemplateOutlet="collectionFilters"></ng-container></div>

      <ng-template dataListItem let-row>
        <strong>{{ row.category }}</strong>
        <div class="br-text-muted">{{ row.message }}</div>
      </ng-template>
      <ng-template dataListDetail let-row>
        <div>{{ row.createdAt | date:'medium':'UTC' }}</div>
        <div>{{ row.userEmail || 'System' }}</div>
        <div *ngIf="row.ipAddress">{{ row.ipAddress }}</div>
      </ng-template>
    </app-data-list>
  </section>
</ng-container>
<ng-template #detailDialog let-row>
  <h2 mat-dialog-title>{{ row.category }}</h2>
  <mat-dialog-content class="br-compact-page">
    <p><strong>Time:</strong> {{ row.createdAt | date:'full' }}</p>
    <p><strong>User:</strong> {{ row.userEmail ?? '(system)' }}</p>
    <p><strong>Event:</strong> {{ row.message ?? '&#8212;' }}</p>
    <p><strong>IP:</strong> {{ row.ipAddress ?? '&#8212;' }}</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button type="button" class="br-btn br-btn--outline-secondary" mat-dialog-close>Close</button>
  </mat-dialog-actions>
</ng-template>
